import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { API_VERSION, BASE_URL } from '../../../environments/environment';
import { LoopBackAuth } from '../sdk/services/core/auth.service';

@Injectable()
export class AccessGroupService {

    public accessGroups: any = [];
    public currentuser: any;

    constructor(private http: Http, private _LoopBackAuth: LoopBackAuth) {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this._getAllAccessGroups();
        if (this.currentuser) {
            this._getAccessGroupInfoForUser(this.currentuser);
        }
    }

    public setAccessGroups(accessgroups) {
        this.accessGroups = accessgroups;
    }

    public getAccessGroups() {
        return this.accessGroups;
    }

    public getAllAccessGroups() {
        return this.http.get(this.getUrl())
            .map(res => res.json())
            .toPromise();
    }

    public getAccessGroupInfoForUser(user) {
        if (user && user.role) {
            let requestOptions = new RequestOptions({
                params: { filter: JSON.stringify({ where: { name: user.role } }) }
            });
            return this.http.get(this.getUrl(), requestOptions)
                .map(res => res.json())
                .toPromise();
        }
    }

    public _getAllAccessGroups() {
        return this.http.get(this.getUrl())
            .map(res => res.json())
            .toPromise()
            .then(data => {
                this.accessGroups = data;
                this.setAccessGroups(this.accessGroups || data);
            }).catch(error => {
                this.accessGroups = null;
                console.log('Error while all access groups>>>>>>>', error);
            });
    }

    public _getAccessGroupInfoForUser(user) {
        let requestOptions = new RequestOptions({
            params: { filter: JSON.stringify({ where: { name: user.role } }) }
        });
        return this.http.get(this.getUrl(), requestOptions)
            .map(res => res.json())
            .toPromise()
            .catch(error => {
                console.log('Error while getting access group>>>>>>>', error);
            });
    }

    public deleteAccessGroup(accessgroupid) {
        return this.http.delete(this.getUrl(accessgroupid));
    }

    public checkIfAccessGroupAlreadyExist(accessgroupname) {
        let requestOptions = new RequestOptions({
            params: { filter: JSON.stringify({ where: { name: accessgroupname } }) }
        });
        return this.http.get(this.getUrl(), requestOptions)
            .map(res => res.json())
            .toPromise();
    }

    public createAccessGroup(accessgroupinfo) {
        return this.http.post(this.getUrl(), accessgroupinfo)
            .map(res => res.json())
            .toPromise();;
    }

    public updateAccessGroup(accessgroupid, accessgroupinfo) {
        return this.http.patch(this.getUrl(accessgroupid), accessgroupinfo)
            .map(res => res.json())
            .toPromise();;
    }

    getUrl(id?: any) {
        if (id) {
            return BASE_URL + '/' + API_VERSION + '/' + 'accessgroups/' + id;
        } else {
            return BASE_URL + '/' + API_VERSION + '/' + 'accessgroups';
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/accessgroup.service.ts